// src/components/Login.tsx
import { yupResolver } from "@hookform/resolvers/yup";
import { EnterIcon, InfoCircledIcon } from "@radix-ui/react-icons";
import {
  Avatar,
  Button,
  Callout,
  Card,
  Flex,
  Link,
  Spinner,
  Text,
} from "@radix-ui/themes";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useMutation } from "react-query";

import { useNavigate, useSearchParams } from "react-router-dom";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import { routes } from "../../../routes";
import { requestNewPassword } from "../../../services/forgotPassword/forgotPassword";
import styles from "../../../styles/Login.module.scss";
import { NewPasswordFormValidation } from "./NewRequestFormValidation";
import { EyeOpenIcon, EyeClosedIcon } from "@radix-ui/react-icons";
import { BASE_URL, UPLOAD_IMAGES } from "../../../utils/constants";
import { useIES } from "../../../hooks/useIES";

const NewPassword: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("Token");
  const id = searchParams.get("Id");
  const [validationSchema, setValidationSchema] = useState<any>(null);
  const { IES, isLoading } = useIES();
  const mutation = useMutation({
    mutationFn: requestNewPassword,
    mutationKey: "requestNewPassword",
    // onSuccess:(data)=>{
    //     if(data){
    //         toast.success("Senha actualizada")
    //     }
    // },
  });

  useEffect(() => {
    const loadSchema = async () => {
      const schema = await NewPasswordFormValidation();
      setValidationSchema(schema);
    };
    loadSchema();
  }, []);

  type FormValues = {
    confirmPassword: string;
    newPassword: string;
  };
  const defaultValues: FormValues = {
    newPassword: "",
    confirmPassword: "",
  };
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues,
    resolver: validationSchema ? yupResolver(validationSchema) : undefined,
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUseNativeValidation: false,
  });

  const onSubmit = handleSubmit(async (request) => {
    try {
      const result = await mutation.mutateAsync({
        ...request,
        token,
        id,
        password: request.newPassword,
      });
      if (!result) {
        mutation.isSuccess = false;
        toast.error(`Não foi possivel actualizar, tente novamente`);
        return;
      }
      toast.success("Senha actualizada");
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  return (
    <div className={styles.loginContainer}>
      <div className={styles.imageSection} style={{
          backgroundImage: `url(${IES.BACKGROUND})`
        }}>
        <img  src={`${IES.LOGO}`} alt="Login" />
      </div>
      <div className={styles.formSection}>
        <Card
          size="3"
          title="New Password"
          variant="classic"
          style={{ width: "50%" }}
        >
          <Flex gap="4" align="center" direction="column">
            <Avatar size="6" fallback="T" src={`${IES.LOGO}`} />
            <Text weight={"bold"} as="label">
              Resetar senha
            </Text>
            {mutation.isSuccess ? (
              <>
                <Callout.Root color="green">
                  <Callout.Icon>
                    <InfoCircledIcon />
                  </Callout.Icon>
                  <Callout.Text>
                    Senha actualizada.
                    <Link onClick={() => navigate(routes.login)}>
                      {" "}
                      Clique aqui para ir ao login!
                    </Link>
                  </Callout.Text>
                </Callout.Root>
              </>
            ) : (
              <>
                <form onSubmit={onSubmit} noValidate>
                  <Flex gap="4" direction="column">
                    <div style={{ position: "relative", width: "100%" }}>
                      <TextFieldComponent
                        name="newPassword"
                        label="Nova senha"
                        control={control}
                        errors={errors}
                        fieldProps={{
                          placeholder: "Senha nova",
                          type: showNew ? "text" : "password",
                           style: { paddingRight: '35px' }
                        }}
                            style={{ width: "100%" }}
                      />

                      <button
                        type="button"
                        onClick={() => setShowNew((prev) => !prev)}
                        style={{
                          position: "absolute",
                          right: "12px",
                          top: "41px",
                          background: "none",
                          border: "none",
                          padding: 0,
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {showNew ? <EyeOpenIcon /> : <EyeClosedIcon />}
                      </button>
                    </div>
                <div style={{ position: "relative", width: "100%", marginTop: '4px' }}>
  <TextFieldComponent
    name="confirmPassword"
    label="Confirmar senha"
    control={control}
    errors={errors}
    fieldProps={{
      placeholder: "Confirmar senha",
      type: showConfirm ? "text" : "password",
       style: { paddingRight: '35px' } 
    }}
    style={{ width: "100%" }}
  />
  <button
    type="button"
    onClick={() => setShowConfirm((prev) => !prev)}
    style={{
      position: "absolute",
      right: "12px",
      top: "41px", 
      background: "none",
      border: "none",
      padding: 0,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    {showConfirm ? <EyeOpenIcon /> : <EyeClosedIcon />}
  </button>
</div>
                    <Button
                      variant="surface"
                      type="submit"
                      disabled={mutation.isLoading}
                    >
                      {mutation.isLoading ? (
                        <>
                          {" "}
                          <Spinner loading>
                            {" "}
                            <EnterIcon />{" "}
                          </Spinner>{" "}
                        </>
                      ) : (
                        <EnterIcon />
                      )}{" "}
                      Confirmar
                    </Button>
                  </Flex>
                </form>
              </>
            )}
          </Flex>
        </Card>
      </div>
    </div>
  );
};

export default NewPassword;
